import {fromJS} from 'immutable';

const defState = fromJS([
    /*{
        image: 'http://dev.logunoliktava.lv/mw/file?width=1200&height=1000&open=left',
        size:{
            x: 1200,
            y: 1000,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 86.99,
        quantity: 3,
        id: '234fg5',
        featured: true,
    },
    {
        image: 'http://dev.logunoliktava.lv/mw/file?width=800&height=1000&open=',
        size:{
            x: 800,
            y: 900,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 44.49,
        quantity: 3,
        id: '234fg6',
        featured: true,
    },
    {
        image: 'http://dev.logunoliktava.lv/mw/file?width=900&height=1000&open=right',
        size:{
            x: 900,
            y: 1000,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 36.49,
        quantity: 3,
        id: '234fg7',
        featured: true,
    },
    {
        image: 'http://dev.logunoliktava.lv/mw/file?width=1500&height=1000&open=',
        size:{
            x: 1500,
            y: 1000,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 44.49,
        quantity: 3,
        id: '234fg8',
        featured: true,
    },
    {
        image: 'http://dev.logunoliktava.lv/mw/file?width=850&height=1000&open=',
        size:{
            x: 850,
            y: 1000,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 44.49,
        quantity: 3,
        id: '234fg9',
        featured: true,
    },
    {
        image: 'http://dev.logunoliktava.lv/mw/file?width=1050&height=1000&open=',
        size:{
            x: 1050,
            y: 1000,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 44.49,
        quantity: 3,
        id: '234fg12',
        featured: true,
    },
    {
        image: 'http://dev.logunoliktava.lv/mw/file?width=800&height=1000&open=left',
        size:{
            x: 600,
            y: 1000,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 44.49,
        quantity: 3,
        id: '234fg1445',
        featured: true,
    },
    {
        image: 'http://dev.logunoliktava.lv/mw/file?width=1000&height=800&pattern=double&left_width=400&right_open=1',
        size:{
            x: 1000,
            y: 800,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 44.49,
        quantity: 3,
        id: '234fg1465',
        featured: true,
        type: 'double',
    },
    {
        image: 'http://dev.logunoliktava.lv/mw/file?width=1200&height=1000&pattern=double&left_open=1&right_open=1&top_height=300',
        size:{
            x: 1200,
            y: 1000,
        },
        new: true,
        frame: 'Алупласт 6камерный (Германия)',
        glass: 'Пилинктон 24 мм селективный, аргон',
        fittings: 'Винкхаус (Германия)',
        color: 'белый',
        price: 44.49,
        quantity: 3,
        id: '234fg1f445',
        type: 'doubleT',
        featured: true,
    },*/
]);

export default function reducer(state = defState, action) {
    switch (action.type) {
        case 'PRODUCTS_LOAD_SUCCESS': {
            console.log(action.payload);
            return action.payload;
        }
        default:
            return state;
    }
};